export default __webpack_public_path__ + "static/Focal_Chili-15ff54802e4db842e8bb78067def5795.png";